import {ValueObject} from '@s-ui/domain'

export class BodyTypeParamsValueObject extends ValueObject {
  /**
   * @param {String} bodyType
   * @param {String} doors
   * @param {String} year
   * */
}
